import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

// Import our core components
import Header from './components/Header';
import IconsList from './components/IconsList';
import SearchBar from './components/SearchBar';

// Import our modal components
import AboutModal from './components/Modal/AboutModal';
import LicenceModal from './components/Modal/LicenceModal';
import RequestModal from './components/Modal/RequestModal';
import PackageModal from './components/Modal/PackageModal';
import DonateModal from './components/Modal/DonateModal';

class App extends Component {

    // We'll use this to store a copy of all icons
    // at all times
    allIcons = [];

    constructor(props) {
        super(props);

        this.state = {
            icons: null,
            usingCahce: false,
        };
    }

    componentDidMount() {
        // Fetch the icons remotely
        fetch('/softies/icons.json')
            .then(res => {
                if (res.ok) {
                    return res.json()
                } else {
                    throw Error(res.statusText);
                }
            })
            .then(icons => {
                // Set allIcons and the current list of icons
                this.allIcons = icons;
                this.setState({icons:this.allIcons});
                localStorage.setItem('iconsCache',  JSON.stringify(this.allIcons));
            })
            .catch(() => {
                // Try to get icons from local storage
                let iconsCache = JSON.parse(localStorage.getItem('iconsCache'));
                if(iconsCache && iconsCache.constructor === Array) {
                    this.allIcons = iconsCache;
                }

                this.setState({
                    icons: this.allIcons ? this.allIcons : [],
                    usingCahce: true
                });
                
            }) 
    }

    render() {
        return (
            <Router basename="/softies">
                <div className="App">

                    { this.state.usingCahce ? 
                    (<div className="offline"><p><strong>Offline mode:</strong> You are viewing a cached list of icons</p></div>) 
                    :  
                    (<div className="package">
                        <p>Want everything at once? <Link to="/package">Get the SVGs, PNGs, IconJar set and Sketch source file.</Link></p>
                    </div>)   
                    }

                    <div className="logo">
                        <a href="http://robbiepearce.com" rel="noopener noreferrer" target="_blank">Robbie Pearce</a>
                    </div>

                    <div className="contact">
                      <a href="mailto:hi@robbiepearce.com">Get in Touch</a>
                    </div>

                    <Header icons={this.allIcons} />

                    {/* Search bar */}
                    <SearchBar valueChanged={(e) => {
                        // When a user searches we want to filter the icons using the keywords.
                        this.setState({icons: this.allIcons.filter(icon => icon.keywords.search(new RegExp(e.target.value, 'i')) >= 0)})
                    }} />

                    <IconsList icons={this.state.icons} />

                    <Route path="/about" exact component={() => <AboutModal />} />
                    <Route path="/licence" exact component={() => <LicenceModal />} />
                    <Route path="/request" exact component={() => <RequestModal />} />
                    <Route path="/package" exact component={() => <PackageModal />} />
                    <Route path="/donate" exact component={() => <DonateModal />} />
                </div>
            </Router>
        );
    }
}

export default App;
